import { extend, configure } from 'vee-validate';
import {
  required,
  email,
  max,
  min,
  numeric,
  max_value,
  excluded,
} from 'vee-validate/dist/rules';
import { i18n } from '../lib/i18n';

configure({
  defaultMessage: (field, values) => {
    // override the field name.
    values._field_ = i18n.t(`fields.${field}`);

    return i18n.t(`validation.${values._rule_}`, values);
  },
});

// Install required rule.
extend('required', required);
extend('required2', required);

// Install email rule.
extend('email', email);

// Install min rule.
extend('min', min);

// Install max rule.
extend('max', max);

extend('max_value', max_value);

// Install excluded rule.
extend('excluded', excluded);
extend('excluded2', excluded);

extend('url', {
  validate: value => {
    return value.indexOf('http://') == 0 || value.indexOf('https://') == 0;
  },
});

extend('password', {
  validate: value => {
    //영문/숫자/특수문자(!@#$%^&*-=?~) 6자이상 조합
    const regex = /(?=.*\d)(?=.*[a-z])(?=.*[\!\@\#\$\%\^\&\*\-\=\?\~]).{6,}/; //eslint-disable-line
    return regex.test(value);
  },
});

extend('fieldmatch', {
  validate(value, { target }) {
    //console.log(value, target);
    return value === target;
  },
  params: ['target', 'targetField'],
  message: (fieldName, placeholders) => {
    return i18n
      .t(`validation.${placeholders._rule_}`)
      .replace('{_field_}', placeholders.targetField);
  },
});

extend('least_one', {
  params: ['target', 'another'],
  validate(value, { target, another }) {
    return value.length > 0 || target.length > 0;
  },
});

// Install numeric rule.
extend('numeric', numeric);

// Install numeric rule.
extend('decimal', {
  params: ['decimals', 'separator'],
  validate: (value, { decimals = '*', separator = '.' } = {}) => {
    if (value === null || value === undefined || value === '') {
      return {
        valid: false,
      };
    }
    if (Number(decimals) === 0) {
      return {
        valid: /^-?\d*$/.test(value),
      };
    }
    const regexPart = decimals === '*' ? '+' : `{1,${decimals}}`;
    const regex = new RegExp(
      `^[-+]?\\d*(\\${separator}\\d${regexPart})?([eE]{1}[-]?\\d+)?$`,
    );

    return {
      valid: regex.test(value),
    };
  },
  //message: 'The {_field_} field must contain only decimal values',
  message: (fieldName, placeholders) => {
    const name = i18n.t(fieldName);
    return i18n
      .t(`validation.${placeholders._rule_}`)
      .replace('{_field_}', name)
      .replace('{decimals}', placeholders.decimals);
  },
});

extend('authreq', {
  params: ['authreq'],
  validate: (value, { authreq }) => {
    //console.log('authreq', value, authreq);
    return authreq;
  },
});

/*
extend('required', {
  ...required,
  message: 'This field is required',
});

extend('max', {
  ...max,
  message: 'This field must be {length} characters or less',
});

extend('email', {
  ...email,
  message: 'This field must be a valid email',
});*/
